export default __webpack_public_path__ + "static/accent2-ff06b5d36da746f91f4772cb2129866c.svg";